module.exports = __webpack_public_path__ + "img/Birthday_201702_4-1024x1024.eaac1131.jpg";